<template>
    <div id="root">
        <h1>
            My Information
        </h1>
        <b-row>
            <b-col cols="3">
                First Name: {{profile.firstName}}
            </b-col>
            <b-col cols="3">
                Middle Name: {{profile.middleName}}
            </b-col>
            <b-col cols="3">
                Last Name: {{profile.lastName}}
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="6">
                Social Security Number: {{profile.ssn}}
                </b-col>
            <b-col cols="6">
                Date of Birth: {{formatDate(profile.dateOfBirth)}}
            </b-col>
        </b-row>
        <hr class="mt-3"/>
        <h2>
            Contact Information
        </h2>
        <b-row>
            <b-col cols="6">
                Cell Phone Number: {{profile.contact.phone}}
            </b-col>
            <b-col cols="6">
                Email Address: {{profile.contact.email}}
            </b-col>
        </b-row>
        <b-row class="mt-3">
            <b-col cols="12" class="font-weight-bold">
                Address
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="8">
                Street Address: {{profile.contact.address.streetAddress}}
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="4">
                City: {{profile.contact.address.city}}
            </b-col>
            <b-col cols="4">
                State: {{profile.contact.address.state}}
            </b-col>
            <b-col cols="4">
                ZIP: {{profile.contact.address.postalCode}}
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="2" class="mt-2 mb-2">
                <b-button variant="primary" size="sm" to="profile-contact-update" role="button">Update Contact Information</b-button>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import axios from "axios"
import axiosRetry from 'axios-retry'
import moment from 'moment'

axiosRetry(axios, { retries: 3,
    retryDelay: axiosRetry.exponentialDelay  })

export default {
    data: () => ({
        profile: {}
    }),
    methods: {
        initialize() {
            axios.get(`${process.env.VUE_APP_API_BASE_URL}/profile/user`)
                .then(response => {
                    this.profile = response.data
                })
        },
        formatDate(unformattedDate){
            let formattedDate = moment(unformattedDate);
            if(!formattedDate.isValid()) return '';
            return formattedDate.format("MM/DD/YYYY")
        }
    },
    created() {
        this.initialize()
        document.title = "My Information - NAR"
    },
}
</script>
<style>
    .paCol { width: 15%; }
</style>